import {z} from 'zod';

import {DiscountTypeSchema, SupplierDiscountLevelSchema} from '@dms/api/warehouse';

export const SupplierDiscountGroupFormSchema = z.object({
  supplierId: z.string(),
  authorizationProfileId: z.string(),
  supplierDiscountGroupCode: z.string(),
  discountType: DiscountTypeSchema,
  discountLevels: z.array(SupplierDiscountLevelSchema),
});

export type SupplierDiscountGroupForm = z.infer<typeof SupplierDiscountGroupFormSchema>;
